import { QueryClientProvider } from '@tanstack/react-query'

import { queryClient } from '@/api/api'
import { client } from '@/api/codegen/client.gen'
import { aipApiBaseUrl } from '@/constants/config.constants'

client.setConfig({
  baseUrl: aipApiBaseUrl,
  credentials: 'include',
})

export function getTanStackQueryContext() {
  return {
    queryClient,
  }
}

export const TanStackQueryProvider = ({
  children,
}: {
  children: React.ReactNode
}) => <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
